type DisplayFileNameInput = {
  fileName?: string | null
  url?: string | null
  externalUrl?: string | null
}

const getFileNameFromPath = (path?: string | null) => {
  if (!path) return ''
  const normalizedPath = path.replace(/^file:\/\//, '')
  const withoutQuery = normalizedPath.split(/[?#]/)[0]
  const segments = withoutQuery.split('/')
  const lastSegment = segments[segments.length - 1] ?? ''
  return decodeURIComponent(lastSegment)
}

const isExternalUrl = (value?: string | null) => {
  if (!value) return false
  return /^https?:\/\//i.test(value) || value.startsWith('file://')
}

const getOriginalNameFromStoredFileName = (fileName: string) => {
  const match = fileName.match(/^.*_[a-f0-9]{32}[a-f0-9]+_(.+)$/i)
  return match?.[1] ?? fileName
}

export const getDisplayFileName = (file: DisplayFileNameInput) => {
  if (file.fileName && !isExternalUrl(file.fileName)) {
    return getOriginalNameFromStoredFileName(file.fileName)
  }

  const filePath = file.externalUrl || file.url || file.fileName || ''
  return getFileNameFromPath(filePath)
}
